import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlined from '@mui/icons-material/LightModeOutlined';
import SettingsBrightnessOutlined from '@mui/icons-material/SettingsBrightnessOutlined';
import IconButton from '@mui/material/IconButton';
import { useColorScheme } from '@mui/material/styles';

type Mode = 'system' | 'light' | 'dark';

const next: Record<Mode, Mode> = { system: 'light', light: 'dark', dark: 'system' };

const labels: Record<Mode, string> = {
  system: 'Theme: follows your device. Switch to light',
  light: 'Theme: light. Switch to dark',
  dark: 'Theme: dark. Switch to follow your device',
};

const icons: Record<Mode, typeof LightModeOutlined> = {
  system: SettingsBrightnessOutlined,
  light: LightModeOutlined,
  dark: DarkModeOutlined,
};

/** Cycles system → light → dark. MUI persists the choice per browser. */
export function ThemeModeToggle() {
  const { mode, setMode } = useColorScheme();
  const current: Mode = mode ?? 'system';
  const Icon = icons[current];

  return (
    <IconButton
      color="inherit"
      aria-label={labels[current]}
      title={labels[current]}
      onClick={() => setMode(next[current])}
    >
      <Icon />
    </IconButton>
  );
}
